import { getAgentCategoryMapping } from '@/utils/agentCategoryDisplayConfig'

const BUILTIN_AGENT_CATEGORY_ICONS = Object.freeze({
  super_agent: 'home-agent-super',
  chat_agent: 'home-ai-chat',
  engineering_web_developer: 'home-ai-web-developer',
  image_generation_agent: 'home-ai-image'
})

export function getBuiltinAgentCategoryIcon(category) {
  return BUILTIN_AGENT_CATEGORY_ICONS[String(category || '').trim()] || ''
}

export function getAgentIconMeta(agent = {}) {
  const category = String(agent.agent_category || '').trim()
  return category ? getAgentCategoryMapping(category)?.icon || null : null
}

export function getAgentMappedIcon(agent = {}) {
  return getAgentIconMeta(agent)?.value || ''
}

export function getAgentMappedIconColor(agent = {}) {
  return getAgentIconMeta(agent)?.color || ''
}

export function hasAgentMappedIcon(agent = {}) {
  return Boolean(getAgentMappedIcon(agent))
}

export function getAgentMappedIconStyle(agent = {}) {
  const meta = getAgentIconMeta(agent)
  if (!meta) return {}

  const style = {}
  if (meta.color) style['--agent-icon-color'] = meta.color
  if (meta.size) style['--agent-icon-size'] = `${meta.size}px`

  return style
}
